<template>
  <div>
    <el-row class="cs-grey-bottom-border">
      <el-col>
        <span class="cs-homework-title">{{data.courseName}}作业情况</span>
      </el-col>
    </el-row>
    <el-row class="cs-grey-bottom-border cs-specificStudentHomeworkList-container">
      <pagination v-loading="loading" :data="listData" :option="paginationOption"></pagination>
    </el-row>
    <el-row class="cs-grey-bottom-border">
      <el-col>
        <span>作业未完成:</span>
        <span class="cs-redLabel">{{incompletedCount}}</span>
      </el-col>
      <el-col>
        <span>平均成绩:</span>
        <span :class="className">{{averageScoreText}}</span>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss">
.cs-grey-bottom-border.cs-specificStudentHomeworkList-container{
  border-bottom: none;
}
</style>

<script>
import { getSpecificStudentHomeworkList } from "../../service/homework.service";
import pagination from "../common/pagination";
import { getScoreColor } from "../../config/mUtils.js";

export default {
  props: {
    data:{
      studentId: Number,
      courseId: Number,
      campusId: Number,
      courseName: String
    }
  },
  data() {
    return {
      loading: false,
      listData: {},
      paginationOption: {},
      incompletedCount: 0,
      averageScore: 0,
      averageScoreText: "",
      className: ""
    };
  },
  components: {
    pagination
  },
  created() {
    this.paginationOption = {
      displayPagination: false,
      hasEditButton: false,
      editButtonText: "查看",
      hasAddButton: false,
      addButtonText: "",
      hasSearch: false,
      editColumnTite: "详情查看",
      showAcitveColor: true,
      hideDisableRow: true,
      hasDeleteButton: false,
    };
   
    this.init();
  },
  methods: {
    init(){
      if (!!this.data){
        this.averageScore = 0;
        this.averageScoreText = "";
        this.className = "";
        this.getListData();
      }
    },
    getListData() {
      this.loading = true;
      getSpecificStudentHomeworkList(
        this.data.studentId,
        this.data.courseId,
        this.data.campusId
      )
        .then(result => {
          if (!!result && result.success) {
            this.listData = result.data;
            this.incompletedCount =
              result.data.AdditionalResult["IncompletedCount"];
            this.averageScore = result.data.AdditionalResult["AverageScore"];
            this.averageScoreText =
              result.data.AdditionalResult["AverageScoreText"];

            if (this.averageScore != null){
              this.className = getScoreColor(this.averageScore);
            }
            
          }
          this.loading = false;
          this.$emit("loaded");
        })
        .catch(() => {
          this.loading = false;
          this.$emit("loaded");
        });
    },
  },
  watch: {
    data: function(){
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/homework/specificStudentHomeworkList.vue